import {ChangeDetectorRef, Component} from '@angular/core';

//import * as LogRocket from 'logrocket'

@Component({
  selector: 'smart-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = 'smartadmin-angular-seed';

  constructor() {
    //LogRocket.init('sgkud8/testlogrocket');
  }
}
